<template>
    <va-create-layout>
        <ImagingServicesFeeEvent-form
            :title="title"
            :item="item"
        ></ImagingServicesFeeEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
